module.exports = __webpack_public_path__ + "img/1.3beaad75.jpg";